module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "data-app": "true"
    }
  }, [(_vm.checkCurrentPage()) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "nav"
    }
  }, [(_vm.checkCurrentPage()) ? _c('LeftNav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "LeftNav",
    staticClass: "navigation",
    attrs: {
      "clickNavMenu": _vm.clickNavMenu
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('router-view', {
    staticClass: "content-container",
    attrs: {
      "id": "content-container"
    }
  }), _vm._v(" "), (_vm.checkCurrentPage()) ? _c('div', {
    ref: "menuBtn",
    staticClass: "sub_menu",
    on: {
      "click": _vm.click_menu
    }
  }, [_c('v-icon', {
    staticClass: "btn"
  }, [_vm._v("menu")])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d505ecfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 870
// module chunks = 1